import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import  not_photo from '../assets/sinfoto.webp'
import { useNavigate } from 'react-router-dom'

const styleButtons = {
  "marginLeft"    : "auto",
  "marginRight"   : "auto",
  "display"       : "table",
  "fontSize"      :"15px"
};

const container_style = {
  "width" : "460px"
};

const profile_photo_style = {
  "width"         : "100%", 
  "borderRadius"  : "15px"
};

function Profile({logout,user}) {

  const navigate = useNavigate();

  const handled_logout = () =>{

    logout(true);
  }

  return (
    <Container style={container_style}>
        <Row>
            <Col>
                <img src={not_photo} className='border' alt="" style={profile_photo_style} />
            </Col>
            <Col>
              <div className="card" style={{"width": "18rem"}}>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item text-center">{user.fullName}</li>
                  <li className="list-group-item text-center">{user.email}</li>
                </ul>

                <Row className='p-0 mt-2 mb-2'>
                  <Col>
                  <Button variant="outline-info" onClick={()=> navigate("profile")} style={styleButtons}>Ver Perfil</Button>
                  </Col>

                  <Col>
                  <Button variant="outline-info" onClick={handled_logout} style={styleButtons}>Cerrar Sesión</Button>
                  </Col>
                </Row>
                
               
              </div>
            </Col>
        </Row>
    </Container>
  )
}

export default Profile